// extracted by mini-css-extract-plugin
export var option = "_2n-0";
export var optionSelected = "_2n-1 _2n-0";
export var optionUnselected = "_2n-2 _2n-0";
export var radioInner = "_2n-5";
export var radioOuter = "_2n-3";
export var radioOuterSelected = "_2n-4 _2n-3";